import type { TwnFocusSidebarUserMenuAppearanceOption } from '@/domains/admin-panel/components/molecules/menu/twn-focus-sidebar-user-menu/TwnFocusSidebarUserMenu.types'

// The popover's frame and EXO's light separators, so every panel off the sidebar reads as one family.
const ACCOUNT_MENU_TOKENS = {
  root: {
    borderColor: '{overlay.popover.border.color}',
    borderRadius: '{overlay.popover.border.radius}',
    shadow: '{overlay.popover.shadow}'
  },
  separator: { borderColor: '{surface.100}' }
} as const

// Shown only while Twine offers dark mode (DEC-2026-060).
const APPEARANCE_OPTIONS: readonly TwnFocusSidebarUserMenuAppearanceOption[] = [
  { appearance: 'system', label: 'System', icon: 'desktop_windows' },
  { appearance: 'light', label: 'Light', icon: 'light_mode' },
  { appearance: 'dark', label: 'Dark', icon: 'dark_mode' }
] as const

// Moved here from the classic sidebar, where the menu store hardcodes it.
const LEGACY_DASHBOARD_PATH = '/dashboards/main'

const TWINE_SITE_URL = 'https://twinepos.com'

export { ACCOUNT_MENU_TOKENS, APPEARANCE_OPTIONS, LEGACY_DASHBOARD_PATH, TWINE_SITE_URL }
